import { isNullOrUndefined } from 'util';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: "app-addqualitynotes",
  templateUrl: "./addqualitynotes.component.html",
  styleUrls: ["./addqualitynotes.component.scss"]
})

export class AddqualitynotesComponent implements OnInit {

  noteMessage: string = "";
  appendmessage: string = "";
  noteSubject: string = "";
  IsEvaluate = false;
  IsDispute = false;
  evaluated = false;
  disputed = false;
  disputeOverTurn = false;
  submitted = false;
  questionId: number;
  qaTicketActivityId: number;
  IsDisputeComplete = false;
  constructor(public dialogRef: MatDialogRef<AddqualitynotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    if (!isNullOrUndefined(this.data)) {
      
      this.noteSubject = this.data.subject;
      this.noteMessage = this.data.message;
      this.IsEvaluate = this.data.IsEvaluate;
      this.IsDispute = this.data.IsDispute;
      this.questionId = this.data.QuestionId;
      this.qaTicketActivityId = this.data.QATicketActivityId;
      this.IsDisputeComplete = this.data.IsDisputeComplete;
    }
  }

  OnCloseConfirm() {
    this.dialogRef.close({ subject: this.noteSubject, message: this.noteMessage, activity: 'addnotes' });
  }

  OnCloseConfirmEvaluate() {
    if (this.IsEvaluate) {
      if (this.evaluated) {
        this.dialogRef.close({ subject: this.noteSubject, message: this.noteMessage, activity: 'evaluate' });
      }
      else {
        this.dialogRef.close({ subject: this.noteSubject, message: this.noteMessage, activity: 'addnotes' });
      }
    }
  }

  OnCloseConfirmDispute() {
    
    if (this.disputed) {
      this.appendmessage = this.noteSubject + " - " + this.noteMessage;
      this.noteSubject = "Dispute Close";
      this.dialogRef.close({
        subject: this.noteSubject, message: this.appendmessage, activity: 'disputecomplete',
        questionid: this.questionId, qaticketactivityid: this.qaTicketActivityId
      });
    } else if (this.disputeOverTurn) {
      this.appendmessage = this.noteSubject + " - " + this.noteMessage;
      this.noteSubject = "Dispute Over Turn";
      this.dialogRef.close({
        subject: this.noteSubject, message: this.appendmessage, activity: 'disputecomplete',
        questionid: this.questionId, qaticketactivityid: this.qaTicketActivityId
      });
    } else {
      this.appendmessage = this.noteSubject + " - " + this.noteMessage;
      this.noteSubject = "Dispute Note";
      this.dialogRef.close({
        subject: this.noteSubject, message: this.appendmessage, activity: 'disputeaddnotes',
        questionid: this.questionId, qaticketactivityid: this.qaTicketActivityId
      });
    }
  }

  OnCloseCancel() {
    this.dialogRef.close('cancel');
  }

  showErrors(form) {
    this.submitted = true;
    form.form.controls.SubjectText.touched = true;
    form.form.controls.MessageText.touched = true;
  }
}
